import { setDependency } from 'shared-lib/dependencies';

import config from '@/config';
import router from '@/router';
import * as locale from '@/locale';
import store from '@/store';
import auth from '@/store/auth';

// set shared-lib dependencies
setDependency('store', store);
setDependency('router', router);
setDependency('auth', auth);
setDependency('config', config);
setDependency('locale', locale);
